import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://dxhttgtsatqzwmyprrih.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR4aHR0Z3RzYXRxendteXBycmloIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkzMjU5MzcsImV4cCI6MjA4NDkwMTkzN30.-SbfBFAXkDicwUtHFEL9vtk1QGi2o2uOWHmtQ8aGcpQ";

if (!window.name || !window.name.startsWith("tab_")) {
  window.name =
    "tab_" + Math.random().toString(36).substring(2) + "_" + Date.now();
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.sessionStorage,
    storageKey: "supabase_auth_" + window.name,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
